export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "ourLead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Our management"])},
        "shortIntro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We develop your software of tomorrow."])},
        "tellMeMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Tell Me More"])},
        "ceoMsg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["We create sustainable digital solutions. With deep expertise in modern software development and artificial intelligence, we support our clients from the initial idea to productive deployment. Our mission is to use technology responsibly and effectively, enabling our clients to remain competitive and innovative in the long run."])}
      },
      "de": {
        "ourLead": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unsere Geschäftsführung"])},
        "shortIntro": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wir entwickeln Ihre Software von morgen."])},
        "tellMeMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mehr erfahren"])},
        "ceoMsg": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wir gestalten nachhaltige digitale Lösungen. Mit fundierter Erfahrung in moderner Softwareentwicklung und künstlicher Intelligenz begleiten wir unsere Kunden von der Idee bis zum produktiven Einsatz. Unser Anspruch ist es, Technologien sinnvoll einzusetzen, damit unsere Kunden langfristig wettbewerbsfähig und innovativ bleiben."])}
      }
    }
  })
}
